"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebSocketTransport = void 0;
/**
 * Browser-only transport (без Node: net, fs, standalone upload).
 * Для nextpda-web и других web-клиентов.
 */
var WebSocketTransport_1 = require("./transport/WebSocketTransport");
Object.defineProperty(exports, "WebSocketTransport", { enumerable: true, get: function () { return WebSocketTransport_1.WebSocketTransport; } });
